(ns logseq.sdk.utils
  (:require [camel-snake-kebab.core :as csk]
            [cljs-bean.core :as bean]
            [clojure.walk :as walk]
            [frontend.handler.plugin :as plugin-handler]
            [frontend.util :as util]
            [goog.object :as gobj]
            [logseq.api.db-based.util :as api-util]
            [logseq.db.frontend.content :as db-content]))

(defn- keep-json-keyword?
  [k]
  (some->> (namespace k)
           (contains? #{"block" "db" "file"})
           (not)))

(def remove-hidden-properties api-util/remove-hidden-properties)

(def ^:private kw-tag "___kw___") ; unlikely in normal strings; change if you prefer

(defn- encode-kw [v]
  (if (keyword? v)
    ;; __kw__ns/name or __kw__name
    (str kw-tag (if-let [ns (namespace v)]
                  (str ns "/" (name v))
                  (name v)))
    v))

(defn normalize-keyword-for-json
  ([input] (normalize-keyword-for-json input true))
  ([input camel-case?]
   (when input
     (let [pid (some-> (gobj/get js/window "$$callerPluginID"))
           plugin (and pid (plugin-handler/get-plugin-inst pid))
           runtime (some-> plugin
                           (gobj/get "sdk")
                           (gobj/get "runtime"))
          cljs? (= "cljs" runtime)]
       (walk/prewalk
        (fn [a]
          (cond
            (and cljs? (keyword? a))
            (encode-kw a)

            (keyword? a)
            (if (keep-json-keyword? a)
              (str a)
              (cond-> (name a)
                camel-case?
                (csk/->camelCase)))

            (uuid? a) (str a)

            (and (map? a) (:block/uuid a) (:block/title a))
            (-> a
                (assoc :block/content (:block/title a)
                       :block/full-title (or (db-content/recur-replace-uuid-in-block-title a)
                                             (:block/title a)))
                remove-hidden-properties)

            :else a)) input)))))

(defn- ref-value->ids
  [value]
  (cond
    (and (map? value) (:db/id value)) (:db/id value)
    (map? value) (update-vals value ref-value->ids)
    (vector? value) (mapv ref-value->ids value)
    (set? value) (set (map ref-value->ids value))
    (sequential? value) (mapv ref-value->ids value)
    :else value))

(defn- property-refs->ids
  [result]
  (walk/postwalk
   (fn [value]
     (if (map? value)
      (reduce-kv (fn [m k v]
                    (assoc m k (if (and (keyword? k)
                                        (or (= :block/tags k)
                                            (keep-json-keyword? k)))
                                 (ref-value->ids v)
                                 v)))
                  (empty value)
                  value)
       value))
   result))

(defn uuid-or-throw-error
  [s]
  (cond
    (uuid? s)
    s

    (util/uuid-string? s)
    (uuid s)

    :else
    (throw (js/Error. (str s " is not a valid UUID string.")))))

(defn jsx->clj
  [^js obj]
  (if (js/goog.isObject obj)
    (-> (fn [result k]
          (let [v (gobj/get obj k)
                k (keyword (csk/->kebab-case k))]
            (if (= "function" (goog/typeOf v))
              (assoc result k v)
              (assoc result k (jsx->clj v)))))
        (reduce {} (gobj/getKeys obj)))
    obj))

(defn result->js
  [result]
  (-> result
      property-refs->ids
      normalize-keyword-for-json
      bean/->js))

(def ^:export to-clj bean/->clj)
(def ^:export jsx-to-clj jsx->clj)
(def ^:export to-js bean/->js)
(def ^:export to-keyword keyword)
(def ^:export to-symbol symbol)
